<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="$router.go(-1)" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; 📬 Log Notifikasi Toko
        </h4>
      </div>

      <div class="alert alert-info">
        Riwayat notifikasi WA & Email yang dikirim ke customer / admin.
        Cek di sini kalau ada complain "notif ga sampai" — bisa lihat status sent / failed + error message.
      </div>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center"><div class="spinner-border"></div></div>
        <div v-else-if="logs.length === 0" class="text-center text-muted p-4">Belum ada notifikasi.</div>
        <table v-else class="table table-sm">
          <thead>
            <tr><th>Waktu</th><th>Event</th><th>Channel</th><th>Recipient</th><th>Status</th><th>Detail</th></tr>
          </thead>
          <tbody>
            <template v-for="log in logs">
              <tr :key="log.id">
                <td><small>{{ formatTime(log.created_at) }}</small></td>
                <td><code>{{ log.event_type }}</code></td>
                <td>
                  <span v-if="log.channel === 'wa'" class="badge badge-success"><i class="fab fa-whatsapp"></i> WA</span>
                  <span v-else-if="log.channel === 'email'" class="badge badge-info"><i class="far fa-envelope"></i> Email</span>
                </td>
                <td>
                  <small>
                    <b>{{ log.recipient_type }}</b><br>
                    {{ log.recipient_phone || log.recipient_email || '-' }}
                  </small>
                </td>
                <td>
                  <span class="badge" :class="statusBadge(log.status)">{{ log.status }}</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-light" @click="toggleExpand(log.id)">
                    <i :class="expanded[log.id] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="expanded[log.id]" :key="'detail-' + log.id" class="bg-light">
                <td colspan="6">
                  <div class="p-3">
                    <div v-if="log.error_message" class="alert alert-danger mb-2">
                      <b>Error:</b> {{ log.error_message }}
                    </div>
                    <h6>Pesan:</h6>
                    <pre class="bg-secondary text-white p-2" style="max-height:300px; overflow:auto; font-size:11px;">{{ log.message || '(empty)' }}</pre>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  data() {
    return { shopId: null, logs: [], isLoading: false, expanded: {} };
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        const r = await axios.get('shops/' + this.shopId + '/notification-log', { params: { limit: 100 } });
        this.logs = r.data.data.logs || [];
      } catch (e) { this.$toast.error('Gagal load'); }
      this.isLoading = false;
    },
    toggleExpand(id) { this.$set(this.expanded, id, !this.expanded[id]); },
    formatTime(t) { return t ? moment(parseInt(t)).format('DD MMM YYYY HH:mm') : '-'; },
    statusBadge(s) {
      return { 'badge-success': s === 'sent', 'badge-danger': s === 'failed', 'badge-secondary': s === 'skipped' };
    },
  },
};
</script>
